<script setup>
import { watchThrottled } from '@vueuse/core';
import { ref } from 'vue';
import axios from 'axios';

const props = defineProps({
    search: {
        type: String,
        required: false,
        default: '',
    },
    url: {
        type: String,
        required: true,
    },
    id: {
        type: String,
        required: true,
    },
    min: {
        type: Number,
        required: false,
        default: 3,
    },
});

const suggestions = ref([]);

watchThrottled(
    () => props.search,
    async (newVal) => {
        if (newVal.length < props.min) {
            suggestions.value = [];
        } else {
            axios
                .get(props.url, {
                    params: { search: newVal },
                })
                .then((response) => {
                    suggestions.value = response.data.items;
                });
        }
    },
    { throttle: 500 },
);
</script>

<template>
    <datalist :id="id">
        <option v-for="suggestion in suggestions" :key="suggestion.value" :value="suggestion.text" />
    </datalist>
</template>
